import actions from './actions'

export default function countryReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
      }
    case actions.LIST_COUNTRIES:
      return {
        ...state,
        result: action.result,
        loading: false,
        loaded: true,
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.message,
      }
    default:
      return state
  }
}
